module.exports = __webpack_public_path__ + "img/sell.d9b8452d.svg";